import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAssetIdFromParams } from "effects/useAssetIdFromParams";
import { useDispatch, useSelector } from "store";
import { fetchAssetById, selectAssetByID } from "store/reducers";
import { PageLoading } from "components/shared";
import PageStage from "components/stages/PageStage";
import { AssetFinancials } from "pages/assets/ListAsset/components/AssetFinancials/AssetFinancials";
import { AssetTracking } from "pages/assets/ListAsset/components/AssetTracking/AssetTracking";
import AssetCalibration from "./components/AssetCalibration/AssetCalibration";
import AssetDetails from "./components/AssetDetails/AssetDetails";
import AssetHistoryContainer from "./components/AssetHistory/AssetHistoryContainer";
import AssetSettings from "./components/AssetSettings";

export const ListAssetPage = () => {
  const dispatch = useDispatch();
  const { section } = useParams();
  const assetId = useAssetIdFromParams();
  const asset = useSelector(selectAssetByID(assetId));

  useEffect(() => {
    dispatch(fetchAssetById(assetId));
  }, [assetId]);

  if (!asset) return <PageLoading />;

  const renderPage = () => {
    switch (section) {
      case "summary":
        return <AssetDetails assetId={asset.id} />;
      case "tracking":
        return <AssetTracking assetId={asset.id} />;
      case "calibration":
        return <AssetCalibration assetId={asset.id} />;
      case "history":
        return <AssetHistoryContainer asset={asset} />;
      case "financials":
        return <AssetFinancials assetId={asset.id} />;
      case "settings":
        return <AssetSettings assetId={asset.id} />;
    }
  };

  return <PageStage>{renderPage()}</PageStage>;
};
